import request from "./request";

export async function login(loginId, loginPwd) {
  let resp = await request().post("/user/login", {
    loginId,
    loginPwd,
  });
  return resp.data;
}

export async function whoAmI() {
  const resp = await request().get("/user/whoami");
  return resp.data;
}

export function loginOut() {
  document.cookie = `token=; path=/; domain=${location.hostname}; max-age:-1`;
}

export async function updateInfo(info = {}) {
  let resp = await request().post("/user/update", info);
  return resp.data;
}
